
const GHObjectType = Object.freeze({
  SLIDER: Symbol('slider'),
  NUMBER: Symbol('number'),
  POINT: Symbol('point'),
  VECTOR: Symbol('vector'),
  BREP: Symbol('brep'),
  GEOMETRY: Symbol('geometry'),
  PANEL: Symbol('panel'),
  RELAY: Symbol('relay'),
  TOGGLE: Symbol('toggle'),
  BUTTON: Symbol('button'),
  VALUELIST: Symbol('valuelist'),
  INTERACTIVELENGTH: Symbol('interactivelength'),
  INTERACTIVEVISIBLE: Symbol('interactivevisible'),
  EMATERIALLIST: Symbol('emateriallist'),
  EPAINTLIST: Symbol('epaintlist'),
  NONE: Symbol('none'),
  getObjectType (type) {
    switch (type) {
      case 'Number Slider':
        return GHObjectType.SLIDER;
      case 'Number':
        return GHObjectType.NUMBER;
      case 'Point':
        return GHObjectType.POINT;
      case 'Vector':
        return GHObjectType.VECTOR;
      case 'Brep':
        return GHObjectType.BREP;
      case 'Geometry':
        return GHObjectType.GEOMETRY;
      case 'Panel':
        return GHObjectType.PANEL;
      case 'Relay':
        return GHObjectType.RELAY;
      case 'Boolean Toggle':
        return GHObjectType.TOGGLE;
      case 'Button':
        return GHObjectType.BUTTON;
      case 'Value List':
        return GHObjectType.VALUELIST;
      case 'EMaterialList':
        return GHObjectType.EMATERIALLIST;
      case 'EPaintList':
        return GHObjectType.EPAINTLIST;
      case 'InteractiveVisible':
        return GHObjectType.INTERACTIVEVISIBLE;
      // case 'InteractiveLength':
      //   return GHObjectType.INTERACTIVELENGTH
      default:
        return GHObjectType.NONE;
    }
  }
});

export default GHObjectType;



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/GHObjectType.js